import gql from 'graphql-tag'

export default gql`
  query getCompanySharedFolders($id: String!) {
    getCompanySharedFolders(company: $id) {
      _id
      name
      companyId
      company {
        name
      }
      lastModified
      createdBy {
        firstName
        lastName
      }
      techpackCount
    }
  }
`
